import React, { useEffect, useMemo, useState } from 'react';

const DISCOUNT_DURATION_SECONDS = (6 * 24 * 60 * 60) + (35 * 60) + 16;
const DISCOUNT_END_AT_KEY = 'reok_discount_end_at';
const OPEN_SIGNIN_POPUP_EVENT = 'reok:open-signin-popup';

const getRemainingSecondsFromEndAt = endAt => {
  const remainingMs = endAt - Date.now();
  return Math.max(0, Math.floor(remainingMs / 1000));
};

const getInitialRemainingSeconds = () => {
  try {
    const savedEndAt = Number(window.localStorage.getItem(DISCOUNT_END_AT_KEY));

    if (!savedEndAt || Number.isNaN(savedEndAt)) {
      const endAt = Date.now() + (DISCOUNT_DURATION_SECONDS * 1000);
      window.localStorage.setItem(DISCOUNT_END_AT_KEY, String(endAt));
      return DISCOUNT_DURATION_SECONDS;
    }

    return getRemainingSecondsFromEndAt(savedEndAt);
  } catch (error) {
    return DISCOUNT_DURATION_SECONDS;
  }
};

const HeaderCoupon = () => {
  const [isClosedCoupon, setIsClosedCoupon] = useState(false);
  const [remainingSeconds, setRemainingSeconds] = useState(getInitialRemainingSeconds);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    let endAt;

    try {
      const savedEndAt = Number(window.localStorage.getItem(DISCOUNT_END_AT_KEY));
      endAt = savedEndAt || (Date.now() + (DISCOUNT_DURATION_SECONDS * 1000));
      window.localStorage.setItem(DISCOUNT_END_AT_KEY, String(endAt));
      setRemainingSeconds(getRemainingSecondsFromEndAt(endAt));
    } catch (error) {
      endAt = Date.now() + (DISCOUNT_DURATION_SECONDS * 1000);
    }

    const timer = setInterval(() => {
      setRemainingSeconds(getRemainingSecondsFromEndAt(endAt));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const timerDisplay = useMemo(() => {
    const days = Math.floor(remainingSeconds / (24 * 60 * 60));
    const hours = Math.floor((remainingSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((remainingSeconds % (60 * 60)) / 60);
    const seconds = remainingSeconds % 60;

    return [days, hours, minutes, seconds].map(unit => String(unit).padStart(2, '0'));
  }, [remainingSeconds]);

  const onClose = () => {
    setIsClosedCoupon(true);
  };

  const onClaimNow = () => {
    window.dispatchEvent(new CustomEvent(OPEN_SIGNIN_POPUP_EVENT));
  };

  return (
    <>
      {!isClosedCoupon && (
        <div
          className="flex justify-content-center align-items-center header-coupon"
          style={{
            background:
              'linear-gradient(90deg, #ff4d6d 0%, #ff7a59 28%, #ff4fb3 56%, #8b5cf6 78%, #4f46e5 100%)',
            minHeight: isMobile ? '56px' : '42px',
            position: 'relative',
          }}
        >
          {isMobile ? (
            <div
              className="text-white"
              style={{
                zIndex: 1,
                position: 'relative',
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                padding: '7px 8px 7px 8px',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  flexShrink: 0,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                  {timerDisplay.map((segment, index) => (
                    <React.Fragment key={`timer-${index}`}>
                      <span
                        style={{
                          background: 'rgba(20, 20, 28, 0.28)',
                          backdropFilter: 'blur(6px)',
                          WebkitBackdropFilter: 'blur(6px)',
                          color: '#fff',
                          borderRadius: '4px',
                          border: '1px solid rgba(255, 255, 255, 0.32)',
                          minWidth: '22px',
                          height: '22px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '10px',
                          fontWeight: 700,
                          letterSpacing: '0.5px',
                        }}
                      >
                        {segment}
                      </span>
                      {index < timerDisplay.length - 1 && (
                        <span style={{ color: '#fff', fontWeight: 700, fontSize: '11px' }}>:</span>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>

              <span
                style={{
                  color: '#fff',
                  fontSize: '11px',
                  fontWeight: 500,
                  whiteSpace: 'normal',
                  overflow: 'visible',
                  textOverflow: 'clip',
                  minWidth: 0,
                  maxWidth: '170px',
                  textAlign: 'center',
                  lineHeight: 1.15,
                }}
              >
                Limited time offer: <strong style={{ fontWeight: 800 }}>50% OFF</strong>
              </span>

              <button
                type="button"
                onClick={onClaimNow}
                style={{
                  position: 'relative',
                  zIndex: 2,
                  border: 'none',
                  borderRadius: '6px',
                  background: '#fff',
                  color: '#111',
                  fontSize: '10px',
                  fontWeight: 700,
                  padding: '6px 9px',
                  lineHeight: 1,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  pointerEvents: 'auto',
                  flexShrink: 0,
                }}
              >
                Claim now →
              </button>
            </div>
          ) : (
            <div
              className="text-white"
              style={{
                zIndex: 1,
                position: 'relative',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                flexWrap: 'wrap',
                padding: '8px 48px 8px 12px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {timerDisplay.map((segment, index) => (
                  <React.Fragment key={`timer-${index}`}>
                    <span
                      style={{
                        background: 'rgba(20, 20, 28, 0.28)',
                        backdropFilter: 'blur(6px)',
                        WebkitBackdropFilter: 'blur(6px)',
                        color: '#fff',
                        borderRadius: '4px',
                        border: '1px solid rgba(255, 255, 255, 0.32)',
                        minWidth: '20px',
                        height: '22px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 700,
                        letterSpacing: '0.5px',
                      }}
                    >
                      {segment}
                    </span>
                    {index < timerDisplay.length - 1 && (
                      <span style={{ color: '#fff', fontWeight: 700 }}>:</span>
                    )}
                  </React.Fragment>
                ))}
              </div>

              <span style={{ color: '#fff', fontSize: '13px', fontWeight: 500, textAlign: 'center' }}>
                Limited time offer: <strong style={{ fontWeight: 800 }}>50% OFF</strong>
              </span>

              <button
                type="button"
                onClick={onClaimNow}
                style={{
                  position: 'relative',
                  zIndex: 2,
                  border: 'none',
                  borderRadius: '6px',
                  background: '#fff',
                  color: '#111',
                  fontSize: '12px',
                  fontWeight: 700,
                  padding: '6px 12px',
                  lineHeight: 1,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  pointerEvents: 'auto',
                }}
              >
                Claim now →
              </button>
            </div>
          )}
          {!isMobile && (
            <button
              type="button"
              onClick={onClose}
              aria-label="Close promotion banner"
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '26px',
                height: '26px',
                borderRadius: '999px',
                border: '1px solid rgba(255, 255, 255, 0.5)',
                background: 'rgba(17, 17, 17, 0.25)',
                color: '#fff',
                fontSize: '13px',
                lineHeight: 1,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 3,
              }}
            >
              ✕
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default HeaderCoupon;
